import React, { useState } from 'react';
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { X, Plus } from 'lucide-react';

export default function TagSelector({ label, options, selected, onChange, testId, max = 5, hint }) {
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState('');
  const available = options.filter(o => !selected.includes(o) && o.toLowerCase().includes(filter.toLowerCase()));

  return (
    <div>
      <Label>{label} {max && <span className="text-xs text-slate-400 font-normal">(up to {max})</span>}</Label>
      {hint && <p className="text-xs text-slate-400 mt-0.5">{hint}</p>}
      <div className="flex flex-wrap gap-2 mt-2 min-h-[36px]">
        {selected.map(tag => (
          <Badge key={tag} variant="secondary" className="bg-brand-navy/5 text-brand-dark border-brand-blue/30 gap-1 pr-1">
            {tag}
            <button onClick={() => onChange(selected.filter(t => t !== tag))} className="ml-1 hover:bg-brand-blue/30 rounded-full p-0.5">
              <X className="h-3 w-3" />
            </button>
          </Badge>
        ))}
        {selected.length < max && (
          <div className="relative">
            <button data-testid={testId} onClick={() => setOpen(!open)}
              className="inline-flex items-center gap-1 text-xs border border-dashed border-slate-300 rounded-full px-3 py-1 text-slate-500 hover:border-brand-blue hover:text-brand-navy transition-colors">
              <Plus className="h-3 w-3" /> Add
            </button>
            {open && (
              <div className="absolute z-50 top-full left-0 mt-1 bg-white border border-slate-200 rounded-lg shadow-lg w-72">
                <div className="p-2 border-b border-slate-100">
                  <Input placeholder="Filter..." value={filter} onChange={(e) => setFilter(e.target.value)}
                    className="h-8 text-xs" autoFocus />
                </div>
                <div className="max-h-48 overflow-y-auto">
                  {available.map(opt => (
                    <button key={opt} onClick={() => { onChange([...selected, opt]); setOpen(false); setFilter(''); }}
                      className="block w-full text-left px-3 py-2 text-sm hover:bg-brand-navy/5 truncate">{opt}</button>
                  ))}
                  {available.length === 0 && <p className="text-xs text-slate-400 p-3">No options available</p>}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
